import ManageValidateTable from './manageValidateTable'

export default ManageValidateTable
